var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resourceImageUrl !== '')?_c('img',{staticClass:"tw-object-cover tw-inline-block tw-align-baseline",class:[
    _vm.size == 'is-small' && !_vm.imageUrl
      ? 'tw-h-4'
      : !_vm.imageUrl
      ? 'tw-h-6'
      : 'tw-h-8',
    _vm.imageUrl ? 'tw-rounded' : '' ],attrs:{"src":_vm.resourceImageUrl}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }